import qs from 'query-string';
import { get, post, put, del } from './baseApi';

export const CashFlowCategoryApi = {
    fetch: (query) => get(`/cashflow/categories?${qs.stringify(query)}`),
    fetchById: (id) => get(`/cashflow/categories/${id}`),
    create: (data) => post('/cashflow/categories', data),
    update: (id, data) => put(`/cashflow/categories/${id}`, data),
    delete: (id) => del(`/cashflow/categories/${id}`),
};

export const CashFlowTransactionApi = {
    fetch: (query) => get(`/cashflow/transactions?${qs.stringify(query)}`),
    fetchSummary: (query) => get(`/cashflow/transactions/summary?${qs.stringify(query)}`),
    fetchById: (id) => get(`/cashflow/transactions/${id}`),
    create: (data) => post('/cashflow/transactions', data),
    update: (id, data) => put(`/cashflow/transactions/${id}`, data),
    delete: (id) => del(`/cashflow/transactions/${id}`),
    uploadAttachment: (data) => post(`/cashflow/transactions/attachments`, data),
};
